'use client'
import OfferLinkArrow from './offer-link-arrow'
import Link from 'next/link'
import useCollection from '@/utils/hooks/useCollection'
import CollectionIcon from '@/components/collection-icon'
import type { Offer } from '@/utils/offers'
import { offerLabel } from '@/utils/offer-inbox'
import OfferItemSummary from './offer-item-summary'
import styles from './offer-dialog.module.css'

export default function OfferTargetSummary({
	offer,
	children,
	showFloor = false
}: {
	offer: Offer
	showFloor?: boolean
	children?: React.ReactNode
}) {
	const { data } = useCollection(offer.scope !== 'item' ? offer.collection_slug || '' : '')
	if (offer.inscription_id)
		return (
			<OfferItemSummary
				id={offer.inscription_id}
				priceSats={showFloor ? offer.price_sats : undefined}
			>
				{children}
			</OfferItemSummary>
		)
	return (
		<div className={styles.inboxItem}>
			<div className={styles.inboxThumbnail} aria-hidden="true">
				<CollectionIcon
					collection={data || { slug: offer.collection_slug, name: offer.collection_slug }}
				/>
			</div>
			<div className={styles.inboxItemCopy}>
				<strong>
					{offer.collection_slug ? (
						<Link href={`/collection/${offer.collection_slug}`}>
							{data?.name || offer.collection_slug}
						</Link>
					) : (
						'Collection offer'
					)}
				</strong>
				<span>{offerLabel(offer)}</span>
				{offer.collection_slug && (
					<Link href={`/collection/${offer.collection_slug}`}>
						View collection <OfferLinkArrow />
					</Link>
				)}
				{children}
			</div>
		</div>
	)
}
